import * as api from '@/lti/api'
import { storeEntities } from '@/students/store/helpers'
import Vue from 'vue'

export default {
  state: {
    events: {},
  },
  mutations: {
    ADD_EVENTS (state, events) {
      storeEntities(events, state.events)
    },
    CLEAR_EVENTS (state) {
      state.events = {}
    },
    TOGGLE_COLLAPSE (state, eventId) {
      // expand and collapse when an event is clicked
      // collapse all other events
      Object.keys(state.events).forEach((key) => {
        const event = state.events[key]
        if (event.id != eventId) {
          event.collapsed = true
        }
      })

      // expand this event
      state.events[eventId].collapsed = !state.events[eventId].collapsed
    },
  },
  actions: {
    get_events ({ commit }, { params }) {
      return api.getEvents(params)
    },

    add_events ({ commit, state }, events) {
      commit('ADD_EVENTS', events)
    },

    post_key ({ commit, state }, payload) {
      Vue.set(payload, 'lti', true)

      if (String(payload.key).length <= 5) {
        return api.postKey(payload)
      } else {
        return api.postTimeKey(payload)
      }
    },

    add_event ({ commit, state }, event) {
      commit('ADD_EVENTS', [event])
    },

    toggle_collapse ({ commit, state }, event_id) {
      commit('TOGGLE_COLLAPSE', event_id)
    },

    clear_events ({ commit, state }) {
      commit('CLEAR_EVENTS')
    },
  },
}
